import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { InformationPageService } from 'src/app/services/informationPage.service';
import { TranslateService } from '@ngx-translate/core';
import { BrowserStorageService } from 'src/app/services/storage.service';
import { InformationPageContent } from 'src/app/intefaces/information-page-content.interface';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html', encapsulation: ViewEncapsulation.None,
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  footerLeftSide: InformationPageContent = { content: ''}
  footerBottomSide: InformationPageContent = { content: ''}

  constructor(
    private pageService: InformationPageService,
    private translate: TranslateService,
    private browserStorageService: BrowserStorageService) { }

  ngOnInit(): void {
    this.initContent(null);
    this.translate.onLangChange.subscribe(
      lang => { this.initContent(lang.lang); }
    );
  }

  private initContent(lang: string): void {
    if (lang == null) {
      lang = this.browserStorageService.get("_lang");
      if (lang == null || lang == '') {
        lang = 'pl';
      }
    }

    this.pageService.getInformationPage(this.pageService.PAGES.FOOTER_LEFT_SIDE, lang).subscribe((response: any) => {
      this.footerLeftSide.content = response.data.page[Object.keys(response.data.page)[0]];
    });

    this.pageService.getInformationPage(this.pageService.PAGES.FOOTER_BOTTOM_SIDE, lang).subscribe((response: any) => {
      this.footerBottomSide.content = response.data.page[Object.keys(response.data.page)[0]];
    });

  }

}
